import React, {useEffect, useState} from 'react';
import './AdvertisingCampaign.scss';
import DynaInput from "../DynaView/DynaInput";
import DynaSelectBox from "../DynaView/DynaSelectBox";
import GetInitialData from "./GetInitialData";
import Loader from "../../Loader";
import DynaDatePicker from "../DynaView/DynaDatePicker";
import DynaButton from "../DynaView/DynaButton";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import AdvertisingCampaignTable from "./AdvertisingCampaignTable";
import {useLocation, useNavigate} from "react-router-dom";
import SubmitAdvertisingCampaignData from "./SubmitAdvertisingCampaignData";

const AdvertisingCampaign = () => {

  const navigateTo = useNavigate();
  const myLocation = useLocation();
  const [tableLoader, setTableLoader] = useState(true)
  const [sendData, setSendData] = useState({
    mode: "add",
    campaignId: "",
    campaignName: "",
    campaignType: "productGroup",
    isActive: "1",
    discountType: "percent",
    startDate: "",
    endDate: "",
    basePercent: 0,
    baseAmount: 0,
    productName: "",
    groupId: "",
    campaignDetail: []
  });
  const [initialData, setInitialData] = useState({
    productGroups: [],
    products: []
  });
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    void GetInitialData(setInitialData, setIsLoad, myLocation, setSendData, sendData)
  }, []);

  useEffect(() => {
    if (sendData?.mode === "add") {
      setSendData({...sendData, campaignDetail: []})
    }
  }, [sendData?.campaignType]);

  const addToTableHandel = async () => {

    if (sendData?.campaignType === "productGroup" && sendData?.groupId === "") {
      return toast.error("گروه کالا را انتخاب کنید")
    }
    if (sendData?.campaignType === "product" && sendData?.productName === "") {
      return toast.error(" کالا را انتخاب کنید")
    }
    if (sendData?.campaignType !== "all") {
      setTableLoader(false)
      let url = ""
      if (sendData?.campaignType === "productGroup") {
        url = "/discountCampaign/?request=getProductsByGroup&groupId=" + sendData?.groupId
      } else {
        url = "/discountCampaign/?request=getProductByName&productName=" + sendData?.productName
      }
      const response = await _axios.get(prefixUrl() + url)
      if (response.data?.status) {
        if (response?.data?.data.length > 0) {
          let temp = []
          if (sendData?.campaignType === "product") {
            temp = [...sendData?.campaignDetail]
          }
          response?.data?.data.forEach((item) => {
            let baseAmount
            if (+sendData?.baseAmount <= item.productPrice) {
              baseAmount = sendData?.baseAmount
            } else {
              baseAmount = item.productPrice
            }

            temp.push({
              uniqId: Math.random() * 13,
              productName: item.productName,
              productPrice: item.productPrice,
              productGroupId: sendData?.groupId,
              productGroupName: sendData?.productName,
              percent: sendData?.basePercent,
              amount: baseAmount,
              checked: true
            })
          })
          setSendData({...sendData, campaignDetail: temp})
          setTableLoader(true)
        }
      } else {
        toast.error(response.data.message)
      }
    }
  }

  const formDataHandler = () => {
    void SubmitAdvertisingCampaignData(sendData, navigateTo)
  }

  try {
    return (
      <section className={"main-advertising-campaign"}>
        {isLoad ?
          <>
            <div className={"row-side"}>
              <div style={{gridColumn: '1/3'}}>
                <DynaInput label={"نام کمپین"}
                           name={"campaignName"}
                           className={"solid-dyna-input"}
                           placeholder={"نام کمپین را وارد کنید"}
                           value={sendData?.campaignName}
                           type={"text"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}/>
              </div>

              <DynaDatePicker label={"از تاریخ"}
                              name={"startDate"}
                              className={"solid-dyna-input"}
                              value={sendData?.startDate}
                              setDataFromComponent={(data) => {
                                setSendData({...sendData, ...data})
                              }}
              />

              <DynaDatePicker label={"تا تاریخ"}
                              name={"endDate"}
                              className={"solid-dyna-input"}
                              value={sendData?.endDate}
                              setDataFromComponent={(data) => {
                                setSendData({...sendData, ...data})
                              }}
              />

              <DynaSelectBox options={[{label: "فعال", value: "1"}, {label: "غیرفعال", value: "0"}]}
                             hasFilter={false}
                             label={"وضعیت"}
                             className={"solid-dyna-input"}
                             value={sendData?.isActive}
                             onChange={(data) => setSendData({...sendData, isActive: data.value})}
              />
            </div>
            {sendData?.mode === "add" && <div className={"row-side row-side-two"}>
              <DynaSelectBox options={[
                {label: "گروه کالا", value: "productGroup"},
                {label: "نام کالا", value: "product"},
                {label: "همه", value: "all"}
              ]}
                             hasFilter={false}
                             label={"براساس"}
                             className={"solid-dyna-input"}
                             value={sendData?.campaignType}
                             onChange={(data) => setSendData({...sendData, campaignType: data.value})}
              />

              {sendData?.campaignType !== "all" &&
                <DynaSelectBox
                  options={sendData?.campaignType === "productGroup" ? initialData?.productGroups : initialData?.products}
                  hasFilter={true}
                  label={sendData?.campaignType === "productGroup" ? "نام گروه" : "نام کالا"}
                  value={sendData?.campaignType === "productGroup" ? sendData?.groupId : sendData?.productName}
                  className={"solid-dyna-input"}
                  onChange={(data) => {
                    if (sendData?.campaignType === "productGroup") {
                      setSendData({...sendData, groupId: data.value, productName: "", productGroupName: data.label})
                    } else {
                      setSendData({...sendData, productName: data.value, groupId: "", productGroupName: ""})
                    }
                  }}/>
              }

              <div className={"chose-discountType"}>
                <label>نوع تخفیف</label>
                <div className={"box-side"}>
                <span style={{borderRadius: "0 5px 5px 0"}}>
                  <input type={"number"} value={sendData?.basePercent} onChange={(e) => {
                    if (+e.target.value <= 100) {
                      setSendData({...sendData, basePercent: e.target.value, baseAmount: 0, discountType: "percent"})
                    }
                  }}/>
                  <h6>درصد</h6>
                </span>
                  <span style={{borderRadius: "5px 0 0 5px"}}>
                  <input value={UtilsFunctions.addCommas(sendData?.baseAmount)} onChange={(e) => {
                    if (!isNaN(UtilsFunctions.removeCommas(e.target.value)) && !e.target.value.includes(" ")) {
                      setSendData({
                        ...sendData,
                        basePercent: 0,
                        baseAmount: UtilsFunctions.removeCommas(e.target.value),
                        discountType: "amount",
                      })
                    }
                  }}/>
                  <h6>تومان</h6>
                </span>
                </div>
              </div>

              <DynaButton className={"simple-but"}
                          type={"button"}
                          onClick={addToTableHandel}>اعمال</DynaButton>

            </div>}
            {sendData?.campaignType !== "all" &&
              <AdvertisingCampaignTable sendData={sendData} setSendData={setSendData} tableLoader={tableLoader}/>
            }

            {sendData?.campaignDetail.length > 0 &&
              <div className={"row-button"}>
                <DynaButton className={"insurance-button"}
                            type={"button"}
                            onClick={formDataHandler}>ثبت</DynaButton>
                <DynaButton className={"insurance-button-cansel"}
                            type={"button"}
                            onClick={() => navigateTo(-1)}>انصراف</DynaButton>
              </div>
            }
          </> : <Loader/>}
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default React.memo(AdvertisingCampaign);